/**
 * 036 R-006 — the one spelling of how long session traffic (sign-in, renew, sign-out, `/me`, and
 * the `/me/preferences` read that rides inside a renewal) waits for an answer before it counts as
 * "could not be asked" rather than merely slow.
 *
 * Five seconds: longer than a read's three (FR-004 — a renewal blocks nothing the practitioner is
 * looking at, so there is no reason to give up as fast as a screen's own load does), shorter than a
 * write's ten (a renewal cut short is simply tried again at the next beat, not replayed against a
 * side effect FR-054 has to make safe).
 *
 * Its own file so that `core/session/session.store.ts` and `core/preferences/preferences.store.ts`
 * — which must not import from each other for this alone — share the same number rather than each
 * writing `5000` and drifting the day one of them changes.
 */
export const SESSION_TIMEOUT_MS = 5000;
